import React from 'react'
import { getAPIFullUrl, getAxiosConfig, getUserAPIToken } from '../risapi';
import { risapi } from '../risapi';





export const getPermissions = async(filterParameters,callback)=>{
    try {
      
        const response = await risapi.get(getAPIFullUrl('/api/milma-admin/permissions', filterParameters),getAxiosConfig());

            console.log("getpermission response",response);
            
        if (response.status === 200) {
            callback(response.data);
        }
    
    } catch (errorResponse) {

        if(errorResponse.status == 403)
        {
            alert("Permission Denied");

        }
        else
        {
            callback(errorResponse);

        }

    }
}

export const getPermissionGroups = async(filterParameters,callback)=>{
    try {
      
        const response = await risapi.get(getAPIFullUrl('/api/milma-admin/permission-groups', filterParameters),getAxiosConfig());

            console.log("getpermission response",response);
            
        if (response.status === 200) {
            callback(response.data);
        }
    
    } catch (errorResponse) {

        if(errorResponse.status == 403)
        {
            alert("Permission Denied");

        }
        else
        {
            callback(errorResponse);

        }

    }
}

export const fetchPermission = async(permissionId,callback)=>{
    try {
     
        const response = await risapi.get('/api/milma-admin/permissions/'+permissionId,getAxiosConfig());


        if (response.status === 200) {
            callback(response.data);
        }
    
    } catch (errorResponse) {

        if(errorResponse.status == 403)
        {
            alert("Permission Denied");

        }
        else
        {
            callback(errorResponse);

        }

    }
}


export const createPermission =  async (newPermission,callback) => {
  
    try {
        // let axiosConfig = {
        //     headers: {
        //         'Content-Type': 'application/json',
        //         'Accept': 'application/json',
        //         "Authorization": "Bearer " + getAxiosConfig()
        //     }
        // };
        
        const response = await risapi.post('/api/milma-admin/permissions', newPermission,getAxiosConfig());

        console.log(response);
        
        if (response.status === 201) {
            callback(response.data);
        }
    } catch (error) {
        callback(error);
    }
}
export const UpdatePermission =  async (editPermission,callback) => {
  
    try {
        // let axiosConfig = {
        //     headers: {
        //         'Content-Type': 'application/json',
        //         'Accept': 'application/json',
        //         "Authorization": "Bearer " + getAxiosConfig()
        //     }
        // };
        editPermission._method = 'put';
        const response = await risapi.post('/api/milma-admin/permissions/'+editPermission.id, editPermission,getAxiosConfig());

        console.log(response);
        
        if (response.status === 200) {
            callback(response.data);
        }
    } catch (error) {
        callback(error);
    }
}
export const destroyPermission =  async (deletePermission,callback) => {
  
    try {
        // let axiosConfig = {
        //     headers: {
        //         'Content-Type': 'application/json',
        //         'Accept': 'application/json',
        //         "Authorization": "Bearer " + getAxiosConfig()
        //     }
        // };
        deletePermission._method = 'delete';
        const response = await risapi.post('/api/milma-admin/permissions/'+deletePermission.id, deletePermission,getAxiosConfig());

        console.log(response);
        console.log("delete response code",response.status);
        
        if (response.status === 204) {
            callback({permission:deletePermission});
        }
    } catch (error) {
        callback(error);
    }
}


export const destroyPermissionsMultiple =  async (ids,callback) => {
  
    try {
     
        var sendData = {};
        sendData.ids = ids;
        sendData._method = 'delete';
        const response = await risapi.post('/api/milma-admin/permissions/delete/multiple',sendData,getAxiosConfig());

        console.log("delete multiple response",response);
        
        if (response.status === 204) {
            callback({permission:ids});
        }
    } catch (error) {
        callback(error);
    }
}